import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { TtsHistoryPanel } from '../components/TtsHistoryPanel';

export function TtsListPage() {
  return (
    <ScrollPage>
      <PageHeader
        title="TTS Clips"
        description="Every TTS render you've created. Save the pending ones to the library, or discard them."
        actions={
          <Button asChild variant="outline">
            <Link to="/voice-files">
              <ArrowRight className="h-4 w-4" />
              Voice library
            </Link>
          </Button>
        }
      />

      <TtsHistoryPanel paginated />
    </ScrollPage>
  );
}
